import {
    VISA_CARD_SELECTED,
    GET_VISA_CARDS_ERROR,
    GET_VISA_CARDS_SUCCESS,
    ADD_VISA_TO_CART_SUCCESS,
    ADD_VISA_TO_CART_ERROR,
    CLEAR_RESET_VISA_FORM,
    GET_VISA_CARDS_NO_INVENTORY,
    RESET_VISA_SELECTED_CARD_UPDATED,
    SELECTED_LOAD_VALUE_UPDATED,
    RESET_SELECTED_LOAD_VALUE_UPDATED,
    CLEAR_BAD_WORDS_FILTER_RESULT,
    FILTER_BAD_WORDS_SUCCESS,
    FILTER_BAD_WORDS_ERROR,
    UPDATE_CUSTOM_LOAD_VALUE,
    RESET_FORMS,
    CLEAR_ADD_TO_CART_RESPONSE,
    FOCUSED_FORM_FIELD,
    GET_VISA_VIRTUAL_GIFT_TEMPLATES_SUCCESS,
    SET_VISA_VIRTUAL_CARD_IMAGE,
    UPDATE_VIRTUAL_FORM_ERRORS,
    UPDATE_PENDING_VIRTUAL_RECIPIENT,
    SET_SELECTED_GIFT_TEMPLATE,
    RESET_VISA_CARDS_UPDATED,
    PRODUCT_DETAILS_SENT_TO_GA,
    SET_SHOW_GIFT_TEMPLATES,
    SET_SCROLL_TO_GIFT_TEMPLATES,
    SET_SHOW_FULL_CARD_LIST,
    SET_CARD_BUILDER_STEP,
    SET_HANDLING_FORM_SUBMIT
} from "../actions/visaCards";
import EGiftRecipient from "../components/Models/EGiftRecipient";

const initialState = {
    cards: [],
    selectedCard: {},
    cardPreviewImageUrl: '',
    getCardsError: false,
    noCardsAvailable: false,
    resetVisaForm: false,
    selectedCardUpdated: false,
    selectedLoadValue: null,
    selectedLoadValueUpdated: false,
    badWordsFilterResult: null,
    customLoadValue: null,
    cartResponse: null,
    cartError: null,
    focusedFieldId: null,
    giftTemplates: [],
    moreGiftTemplates: [],
    defaultGiftTemplate: null,
    initialGiftTemplateSelected: false,
    selectedGiftTemplate: null,
    virtualErrors: {},
    pendingVirtualRecipient: new EGiftRecipient(),
    visaCardsUpdated: false,
    productDetailsSentToGA: false,
    showGiftTemplates: false,
    scrollToGiftTemplates: false,
    cardBuilderStep: 1,
    showFullCardList: true,
    handlingFormSubmit: false
};

export default function appReducer(state = initialState, action) {
    switch (action.type) {
        case GET_VISA_CARDS_SUCCESS:
            return {
                ...state,
                cards: action.data,
                visaCardsUpdated: true,
                cardPreviewImageUrl: action.data[0].card_image_url,
            };
        case GET_VISA_CARDS_ERROR:
            return {
                ...state,
                getCardsError: action.data
            };
        case GET_VISA_CARDS_NO_INVENTORY:
            return {
                ...state,
                noCardsAvailable: true
            };
        case VISA_CARD_SELECTED:
            // move selected card to the front of the cards array
            const selectedCardIndex = state.cards.indexOf(action.data);
            state.cards.splice(selectedCardIndex, 1);
            state.cards.unshift(action.data);
            const newCardsArray = state.cards;

            return {
                ...state,
                selectedCard: action.data,
                cards: newCardsArray,
                cardPreviewImageUrl: action.data.card_image_url,
                selectedCardUpdated: true,
                cardBuilderStep: state.cardBuilderStep < 2 ? 2 : state.cardBuilderStep,
                showFullCardList: state.cardBuilderStep < 2 ? false : state.showFullCardList
            };
        case ADD_VISA_TO_CART_SUCCESS:
            return {
                ...state,
                cartResponse: action.data,
                resetVisaForm: true,
                selectedCard: {},
                selectedCardUpdated: true,
                cardBuilderStep: 1,
                selectedLoadValue: null,
                selectedLoadValueUpdated: true,
                customLoadValue: null,
                showFullCardList: true,
                handlingFormSubmit: false
            };
        case ADD_VISA_TO_CART_ERROR:
            return {
                ...state,
                cartError: action.data
            };
        case CLEAR_ADD_TO_CART_RESPONSE:
            return {
                ...state,
                cartResponse: null,
                cartError: null
            };
        case CLEAR_RESET_VISA_FORM:
            return {
                ...state,
                resetVisaForm: false,
            };
        case RESET_VISA_SELECTED_CARD_UPDATED:
            return {
                ...state,
                selectedCardUpdated: false
            };
        case SELECTED_LOAD_VALUE_UPDATED:
            return {
                ...state,
                selectedLoadValue: action.data,
                selectedLoadValueUpdated: true
            };
        case RESET_SELECTED_LOAD_VALUE_UPDATED:
            return {
                ...state,
                selectedLoadValueUpdated: false
            };
        case UPDATE_CUSTOM_LOAD_VALUE:
            return {
                ...state,
                customLoadValue: action.value
            };
        case FILTER_BAD_WORDS_SUCCESS:
            return {
                ...state,
                badWordsFilterResult: action.data,
            };
        case FILTER_BAD_WORDS_ERROR:
            return {
                ...state,
                badWordsFilterError: action.data,
            };
        case CLEAR_BAD_WORDS_FILTER_RESULT:
            return {
                ...state,
                badWordsFilterResult: null,
                badWordsFilterError: null
            };
        case RESET_FORMS:
            return {
                ...state,
                customLoadValue: null,
                selectedLoadValue: 50,
                pendingVirtualRecipient: new EGiftRecipient()
            };
        case FOCUSED_FORM_FIELD:
            return {
                ...state,
                focusedFieldId: action.fieldId
            };
        case GET_VISA_VIRTUAL_GIFT_TEMPLATES_SUCCESS:
            return {
                ...state,
                defaultGiftTemplate: action.payload.templates.slice(0)[0],
                giftTemplates: action.payload.templates.slice(1, 3),
                moreGiftTemplates: action.payload.templates.slice(4)
            };
        case SET_VISA_VIRTUAL_CARD_IMAGE:
            return {
                ...state,
                cardPreviewImageUrl: action.payload
            };
        case UPDATE_VIRTUAL_FORM_ERRORS:
            return {
                ...state,
                virtualErrors: action.payload
            };
        case UPDATE_PENDING_VIRTUAL_RECIPIENT:
            return {
                ...state,
                pendingVirtualRecipient: action.payload
            };
        case SET_SELECTED_GIFT_TEMPLATE:
            return {
                ...state,
                initialGiftTemplateSelected: true,
                selectedGiftTemplate: action.payload
            };
        case RESET_VISA_CARDS_UPDATED:
            return {
                ...state,
                visaCardsUpdated: false
            };
        case PRODUCT_DETAILS_SENT_TO_GA:
            return {
                ...state,
                productDetailsSentToGA: true
            };
        case SET_SHOW_GIFT_TEMPLATES:
            return {
                ...state,
                showGiftTemplates: true,
                scrollToGiftTemplates: true
            };
        case SET_SCROLL_TO_GIFT_TEMPLATES:
            return {
                ...state,
                scrollToGiftTemplates: action.payload
            };
        case SET_SHOW_FULL_CARD_LIST:
            return {
                ...state,
                showFullCardList: action.showList
            };
        case SET_CARD_BUILDER_STEP:
            return {
                ...state,
                cardBuilderStep: action.step
            };
        case SET_HANDLING_FORM_SUBMIT:
            return {
                ...state,
                handlingFormSubmit: action.isHandling
            };
        default:
            return state;
    }
}